import React, { useState } from 'react';
import { Box, Button, Grid2, TextField, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import styles from './styles';
import classNames from 'classnames';
import {
  AlternateEmail,
  LockOutlined,
  RemoveRedEye,
  VisibilityOff,
} from '@mui/icons-material';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { login } from '../../js/actions/userActions';

const useStyles = makeStyles(styles);

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const classes = useStyles();
  const rootClassName = classNames(classes.root);
  const dispatch = useDispatch();
  const [showPassword, setShowPassword] = useState(false);
  const intl = useIntl();

  const handleSubmit = (event) => {
    event.preventDefault();
    const user = { email, password };
    dispatch(login(user));
  };

  const isValid = !email || !password;

  return (
    <Box className={rootClassName}>
      <Grid2 container={true} className={classes.grid} size={12}>
        <Grid2 className={classes.content} size={{ lg: 12, xs: 12 }}>
          <div className={classes.contentWrapper}>
            <div className={classes.formBox}>
              <div className={classes.contentBody}>
                <form className={classes.form} onSubmit={handleSubmit}>
                  <div className={classes.divImage}>
                    <img
                      alt="Metimur Logo"
                      src="/images/logo-metimur.png"
                      width={140}
                    />
                  </div>
                  <div className={classes.fields}>
                    <TextField
                      className={classes.textField}
                      id="email"
                      placeholder={intl.formatMessage({
                        id: 'app.login.email',
                      })}
                      variant="outlined"
                      size="medium"
                      onChange={(event) => setEmail(event.target.value)}
                      value={email}
                      slotProps={{
                        input: {
                          startAdornment: <AlternateEmail />,
                        },
                      }}
                      type="email"
                    />
                    <TextField
                      className={classes.textField}
                      id="password"
                      placeholder={intl.formatMessage({
                        id: 'app.login.password',
                      })}
                      variant="outlined"
                      size="medium"
                      onChange={(event) => setPassword(event.target.value)}
                      value={password}
                      slotProps={{
                        input: {
                          startAdornment: <LockOutlined />,
                          endAdornment: (
                            <div>
                              {showPassword === true ? (
                                <RemoveRedEye
                                  sx={{ cursor: 'pointer' }}
                                  onClick={() => setShowPassword(!showPassword)}
                                />
                              ) : (
                                <VisibilityOff
                                  sx={{ cursor: 'pointer' }}
                                  onClick={() => setShowPassword(!showPassword)}
                                />
                              )}
                            </div>
                          ),
                        },
                      }}
                      type={showPassword === true ? 'text' : 'password'}
                    />
                  </div>
                  <Button
                    className={classes.signInButton}
                    color="secondary"
                    disabled={isValid}
                    size="large"
                    type="submit"
                    variant="contained"
                  >
                    {intl.formatMessage({ id: 'app.login.btnInitSession' })}
                  </Button>
                  <Link className={classes.iconTable} to="/recoveredEmail">
                    <Typography
                      color="secondary"
                      sx={{
                        marginTop: '10px',
                        textAlign: 'center',
                        fontWeight: 500,
                        textDecoration: 'none',
                      }}
                    >
                      {intl.formatMessage({ id: 'app.login.recoverPassword' })}
                    </Typography>
                  </Link>
                </form>
              </div>
            </div>
          </div>
        </Grid2>
      </Grid2>
    </Box>
  );
}
